import Vue from 'vue'
import Router from 'vue-router'
import Management from './components/Management'
import SubmitOuting from './components/SubmitOuting'
import BowlerHistory from './components/BowlerHistory'
import NotFound from './components/NotFound'
import TeamOutings from './components/TeamOutings'
import GameEditor from './components/GameEditor'

Vue.use(Router)

export default new Router({
  mode: 'history',
   history: true,
  base: process.env.BASE_URL,
  routes: [
     {
        path: "*",
        component: NotFound
     },
    {
      path: '/',
      name: 'home',
      component: SubmitOuting
    },
      {
        path: '/bowlerHistory',
        name: 'bowlerHistory',
        component: BowlerHistory
      },
     {
        path: '/teamOutings',
        name: 'teamOutings',
        component: TeamOutings
     },
    {
        path: '/Management',
        name: 'Management',
        component: Management
    },
    {
        path: '/submitOuting',
        name: 'submitOuting',
        component: SubmitOuting
    },
    {
        path: '/gameEditor',
        name: 'gameEditor',
        component: GameEditor
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
